import { buildGet } from 'api/builders';

export const index = ({ locationId, dispatch }) => buildGet({
  url: `sign_up/api/menu/modifier_groups?location_id=${locationId}`,
  dispatch,
});
